import React, { CSSProperties } from "react";
import classes from "./FooterMain.module.scss";
import { Container } from "react-bootstrap";
import CustomImage from "../../CustomImage";
import CustomLink from "../../CustomLink";

const customNav = (navData: any, style: CSSProperties = {}) => {
  return (
    <div style={style}>
      {navData?.length > 0 &&
        navData.map((nav: any) => {
          return (
            <div key={nav.id}>
              <div className={classes.linkHeader}>
                <CustomLink data={nav}>{nav.title}</CustomLink>
                {nav.title === "Upcoming Events" && <span className={classes.weHireBtn}> new! </span>}
              </div>
              <ul>
                {nav?.subNav?.length > 0 &&
                  nav.subNav.map((sub: any) => (
                    <li key={sub.id}>
                      <CustomLink data={sub}>{sub.label}</CustomLink>
                      {sub.label === "Careers" && <span className={classes.ipadHiring}> wE’RE hIRING! </span>}
                      {sub.label === "Careers" && <span className={classes.ipad}> HIRING! </span>}
                    </li>
                  ))}
              </ul>
            </div>
          );
        })}
    </div>
  );
};

const FooterMain: React.FC<{ footerData: any }> = ({ footerData }) => {
  return (
    <Container>
      <div className={classes.lineBottom} />
      <div id="footerLinks" className={classes.footerLinks}>
        <div className={classes.footerKClogo}>
          <div id="kcLogoFoot" className={classes.kclogo}>
            <CustomImage src={footerData?.footerImageUrl} alt={footerData?.FooterImageAltTag} height={35} width={160} />
          </div>
          <h3 className={classes.aboutkc}>{footerData?.footerTitle || ""}</h3>
          <div id="kcabtDiscri">{footerData?.footerDescription || ""}</div>
          <div className={classes.icefBadge}>
            <span id="iasBadge" data-account-id="1646"></span>
          </div>
        </div>
        {footerData?.navigationsThree?.length > 0 && customNav(footerData?.navigationsThree)}
        {footerData?.navigationsTwo?.length > 0 && customNav(footerData?.navigationsTwo)}
        {footerData?.navigationsOne?.length > 0 && customNav(footerData?.navigationsOne)}
      </div>
    </Container>
  );
};

export default FooterMain;
